import { render, staticRenderFns } from "./Lojista.vue?vue&type=template&id=895eae52&scoped=true"
import script from "./Lojista.vue?vue&type=script&lang=js"
export * from "./Lojista.vue?vue&type=script&lang=js"
import style0 from "./Lojista.vue?vue&type=style&index=0&id=895eae52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895eae52",
  null
  
)

export default component.exports